import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as routeLink from "../../constants/routeLink";
import { useNavigate } from 'react-router-dom';
const Index = (props) => {
  const dispatch = useDispatch()
  const { appReducer } = useSelector(state => state);
  const navigate=useNavigate();
  return (
    
    <div className='w-100 d-flex justify-content-between align-items-center process-bar'>
          <div className='process w-50 h-100'></div>
    </div>
  )
}

export default Index;
